module.exports = __webpack_public_path__ + "img/Andaluza-13-min.33ba5261.jpg";